import { DialogTitle as HeadlessDialogTitle } from "@headlessui/react";
import { classNames } from "../../utils/classNames";
import { DialogClose } from "./DialogClose";

export function DialogTitle({
  className,
  onClose,
  ...props
}: React.ComponentPropsWithoutRef<"div"> & {
  onClose?: (value: boolean) => void;
}) {
  return onClose ? (
    <div className="flex items-start justify-between">
      <HeadlessDialogTitle
        {...props}
        className={classNames(
          "text-balance text-lg/6 font-medium text-primary sm:text-base/6",
          className,
        )}
      />
      <DialogClose onClick={() => onClose(false)} />
    </div>
  ) : (
    <HeadlessDialogTitle
      {...props}
      className={classNames(
        "text-balance text-lg/6 font-semibold text-primary sm:text-base/6",
        className,
      )}
    />
  );
}
